import { FC } from 'react';
import { createPortal } from 'react-dom';

import loadingGif from './elementary-school-loader-image.gif';

import './elementary-school-loader.scss';

type Props = {
  text?: string;
};

export const ElementarySchoolLoader: FC<Props> = ({ text }) => {
  return createPortal(
    <div className="loading" role="alert">
      <img
        className="loading__img"
        src={loadingGif}
        alt="loading"
        aria-hidden
      />
      <p className="loading__text">{text ?? 'Loading'}</p>
    </div>,
    document.body,
  );
};
